import { render } from "./CheckAllowed.vue?vue&type=template&id=35921b3a&scoped=true&ts=true"
import script from "./CheckAllowed.vue?vue&type=script&lang=ts"
export * from "./CheckAllowed.vue?vue&type=script&lang=ts"

import "./CheckAllowed.vue?vue&type=style&index=0&id=35921b3a&scoped=true&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35921b3a"]])

export default __exports__